import MatchColor from "../../components/UKG/Mathematics/MatchColor";


// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/ukg/mathematics/colors/match-color", title: "Match Color", component: MatchColor},
];


export default topics;